import "./AssinaturaPage.css";

const CheckIcon = () => (
  <svg viewBox="0 0 12 12">
    <polyline points="2 6 5 9 10 3" />
  </svg>
);

const PLANS = [
  {
    id: "basico",
    name: "Básico",
    price: "49,90",
    desc: "Ideal para começar a vender no marketplace.",
    features: [
      "Até 10 produtos cadastrados",
      "Perfil de empresa básico",
      "Visibilidade no marketplace",
      "Chat com compradores",
      "Suporte por e-mail",
    ],
    featured: false,
    cta: "Assinar Básico",
  },
  {
    id: "profissional",
    name: "Profissional",
    price: "99,90",
    desc: "Para fornecedores que querem crescer com mais visibilidade.",
    features: [
      "Até 50 produtos cadastrados",
      "Perfil de empresa completo",
      "Anúncios em destaque",
      "Chat direto com compradores",
      "Relatórios de desempenho",
      "Suporte prioritário",
    ],
    featured: true,
    cta: "Assinar Profissional",
  },
  {
    id: "ilimitado",
    name: "Ilimitado",
    price: "199,90",
    desc: "Escala máxima para grandes fornecedores.",
    features: [
      "Produtos ilimitados",
      "Perfil verificado premium",
      "Posição preferencial nos resultados",
      "Múltiplos usuários",
      "Analytics avançado",
      "Gerente de conta dedicado",
    ],
    featured: false,
    cta: "Assinar Ilimitado",
  },
];

const AssinaturaPage = () => {
  return (
    <div className="assinatura fade-in">
      <div className="assinatura__hero">
        <h1>Escolha seu plano</h1>
        <p>
          Divulgue seus produtos para compradores B2B em todo o Brasil.
          Cancele quando quiser.
        </p>
      </div>

      <div className="assinatura__grid">
        {PLANS.map((plan) => (
          <div
            key={plan.id}
            className={`plan-card${plan.featured ? " plan-card--featured" : ""}`}
          >
            {plan.featured && (
              <span className="plan-badge">Mais popular</span>
            )}

            <p className="plan-card__name">{plan.name}</p>

            <div className="plan-card__price">
              <span className="plan-card__currency">R$</span>
              <span className="plan-card__amount">{plan.price}</span>
              <span className="plan-card__period">/mês</span>
            </div>

            <p className="plan-card__desc">{plan.desc}</p>

            <div className="plan-card__divider" />

            <ul className="plan-card__features">
              {plan.features.map((feat) => (
                <li key={feat} className="plan-card__feature">
                  <span className="plan-card__check">
                    <CheckIcon />
                  </span>
                  {feat}
                </li>
              ))}
            </ul>

            <button
              className={`plan-card__cta ${
                plan.featured ? "plan-card__cta--dark" : "plan-card__cta--light"
              }`}
            >
              {plan.cta}
            </button>
          </div>
        ))}
      </div>

      <p className="assinatura__note">
        Todos os planos incluem 7 dias grátis · Sem fidelidade · Cancele a qualquer momento
      </p>
    </div>
  );
};

export default AssinaturaPage;
